/**
 * Exposure component module.
 * @module shared/components/Exposure
 *
 */
import React from 'react';
import PropTypes from 'prop-types';
import Pie from '../../../../shared/components/graphs/Pie';
import useSWR from 'swr';
import {ColorBox, getColorListPrimary, getColor} from '../../../../shared/utils/colors';
import {Column, Dropdown, LoadingSpinner} from '../../../../shared';
import {formatter} from '../../../../shared/utils/utils';

const percentFormatter = formatter('number', {decimalPlaces: 1});

const exposureTitle = row => <><ColorBox color={row.color}/>{row.name}</>;

const ExposureSecuritiesGraph = ({containerID, category, types, initialType}) => {
  const [type, setType] = React.useState(initialType);
  const colors = React.useMemo(() => [...getColorListPrimary()], []);

  const {data} = useSWR(containerID && `/containers/${containerID}/exposures/${category}/${type.value}`);

  const buildType = d => ({
    id: d.id,
    name: d.name,
    color: getColor(colors),
    value: d.value,
    y: Math.round(d.percent * 1000) / 10,
  });

  const formattedData = React.useMemo(() => {
    if (data) {
      if (data.length) {
        return data.map(buildType);
      }
      return [
        {
          name: 'No Holdings',
          color: '#797B83',
          y: 100,
        },
      ];
    }
  }, [data]);

  if (!formattedData) {
    return <LoadingSpinner/>;
  }
  // TODO Reqs Height of Exposure Securities Modal table
  return <Column justifySubColumn={'top'} height={'500px'}>
    <Dropdown dataPoint={{
      name: 'type',
      value: type,
    }}
              isClearable={false}
              isSearchable={false}
              onChange={(name, value) => setType(value)}
              title={'Exposure Category'}
              options={types}
              placeholder={'Exposure Category'}/>
    <Pie data={formattedData}
         alignTop={true}
         table={{
           defaultSort: {
             column: 'value',
             desc: true,
           },
           columns: [
             {
               title: 'Holdings',
               dataPoint: 'name',
               type: 'text',
               render: exposureTitle,
               minWidth: 120,
               isSortable: true,
               verticalAlign: true,
             },
             {title: 'Market Value', dataPoint: 'value', type: 'currency', minWidth: 100, isSortable: true},
             {
               title: 'Percentage',
               dataPoint: 'y',
               type: 'number',
               render: row => `${row.y}%`,
               minWidth: 90,
               isSortable: true,
             },
           ],
         }}
         toolTipFormatter={function toolTipFormatter() {
           const p = this.point || this.points[0];
           if (['No Asset Classes', 'No Sectors'].indexOf(p.name) < 0) {
             return '<div>'
               + p.name.substr(0, 50)
               + ': </div><div style="font-size:13px;margin-top:3px;" class="text-center">'
               + percentFormatter(p.y)
               + '%</div>';
           }
           return '<div>' + p.name.substr(0, 50) + '</div>';
         }}/>
  </Column>;
};

export default ExposureSecuritiesGraph;

ExposureSecuritiesGraph.propTypes = {
  containerID: PropTypes.number.isRequired,
  types: PropTypes.arrayOf(PropTypes.object).isRequired,
  category: PropTypes.string.isRequired,
  initialType: PropTypes.string.isRequired,
};
